import { Typography } from "@material-ui/core";
import "./Intro.css";
import { logEvent } from "../util/logUtil";

const Intro = () => {
    return (
        <div
            style={{
                padding: "5px",
                width: "100%",
                height: "100%",
            }}
        >
            <Page1 />
        </div>
    );
};

const Page1 = () => {
    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                textAlign: "center",
            }}
        >
            <Typography
                variant="h5"
                style={{
                    paddingLeft: "20px",
                    paddingRight: "20px",
                }}
            >
                Our website is under construction 🚧
            </Typography>
            <div
                style={{
                    margin: "20px",
                }}
            >
                <Typography variant="body1">
                    In the mean time, check out our Android app:
                </Typography>
            </div>
            <a
                href="https://bit.ly/moviepal_android"
                target="_blank"
                rel="noreferrer"
                onClick={() => logEvent("PlayStore badge clicked")}
            >
                <img
                    id="play_store_badge"
                    alt="Get it on Google Play"
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                />
            </a>
        </div>
    );
};

export default Intro;
